'use client';
import { jsx } from '@emotion/react/jsx-runtime';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CheckIcon = function(props) {
    return /*#__PURE__*/ jsx("svg", _extends({
        fill: "none",
        height: "8",
        viewBox: "0 0 10 8",
        width: "10",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ jsx("path", {
            clipRule: "evenodd",
            d: "M9.6626 0.626724C10.0437 0.98719 10.0527 1.59093 9.68242 1.96255L4.23865 7.42669C3.86365 7.78139 3.25567 7.78139 2.88068 7.42669L0.340452 4.96219C-0.0403543 4.59274 -0.0364724 3.9804 0.348987 3.61581C0.712601 3.27187 1.28291 3.27643 1.64098 3.62614L3.55966 5.5L8.35864 0.648411C8.71516 0.287983 9.29429 0.27835 9.6626 0.626724Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    }));
};
var IndeterminateIcon = function(props) {
    return /*#__PURE__*/ jsx("svg", _extends({
        fill: "none",
        height: "2",
        viewBox: "0 0 10 2",
        width: "10",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ jsx("rect", {
            fill: "currentColor",
            height: "2",
            rx: "1",
            width: "10"
        })
    }));
};
var CheckboxIcon = function(_param) {
    var indeterminate = _param.indeterminate, others = _object_without_properties_loose(_param, [
        "indeterminate"
    ]);
    if (indeterminate) {
        return /*#__PURE__*/ jsx(IndeterminateIcon, _extends({}, others));
    }
    return /*#__PURE__*/ jsx(CheckIcon, _extends({}, others));
};

export { CheckIcon, CheckboxIcon, IndeterminateIcon };
